import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox"]

  toggle() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  syncSelectAll() {
    const allChecked = this.checkboxTargets.every((checkbox) => checkbox.checked)
    this.selectAllTarget.checked = allChecked
  }
}
